<template>
    <div class="dashboard-container">
      <table-card style="margin-top:30px" />
    </div>
</template>

<script>

import { 
tableCard
} from '@/components/auth/guild'
export default {
  name: "authGuild",
  components: {
    tableCard
  },
  data() {
    return {

    };
  },
  computed: {
  },
  mounted(){

  },
  methods: {

  }
};
</script>

<style lang="less" scoped>
.dashboard-container {
  width: 100%;
}
</style>
